<template>
  <div class="d-flex flex-column w-100">
    <p class="w-100 font-weight-600 text-center font-md font-md-lg">
      {{ message }}
    </p>

    <div class="d-flex align-items-stretch w-100 shadow-type-4 radius-small">
      <div class="flex-column flex-sm-row flex-center w-33 text-center p-3 radius-tl-small radius-bl-small">
        <svg-icon
          icon="hair-back"
          size="md"
          class="mb-3 mb-sm-0 mr-0 mr-sm-3" />
        <span class="font-md font-md-lg">Hair pulled back</span>
      </div>
      <div class="flex-column flex-sm-row flex-center w-33 text-center p-3 shadow-type-4">
        <svg-icon
          icon="no-glasses"
          size="md"
          class="mb-3 mb-sm-0 mr-0 mr-sm-3" />
        <span class="font-md font-md-lg">Take off glasses</span>
      </div>
      <div class="flex-column flex-sm-row flex-center w-33 text-center p-3 radius-tr-small radius-br-small">
        <svg-icon
          icon="proper-lightning"
          size="md"
          class="mb-3 mb-sm-0 mr-0 mr-sm-3" />
        <span class="font-md font-md-lg">Use proper lighting</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ScanTips',
    props: {
      message: {
        type: String,
        required: true
      },
    },
  }
</script>
